<template>
  <div class="trainee-list-modal-overlay">
    <transition name="modal-expand">
      <div v-if="isVisible" class="trainee-list-modal" @click.stop>
        <div class="modal-content">
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <h2>Revisions for Task ID: {{ taskId }}</h2>
          <div class="revisions-container">
            <div v-for="(dateGroups, groupKey) in groupedRevisions" :key="groupKey" class="revision-group">
              <div v-for="(revisions, dateKey) in dateGroups" :key="groupKey + '-' + dateKey"
                class="revision-sub-group">
                <div class="revision-header" @click="toggleGroup(groupKey + '#' + dateKey)">
                  <h3>
                    {{ groupKey.split('#')[0] }} #{{ groupKey.split('#')[1] }}
                    <span class="date-subtext">— {{ dateKey }}</span>
                  </h3>
                  <span>({{ revisions.length }} changes)</span>
                  <span class="toggle-icon">
                    <font-awesome-icon :icon="openGroups.includes(groupKey + '#' + dateKey) ? 'chevron-up' : 'chevron-down'" />
                  </span>
                </div>

                <transition name="slide-expand">
                  <div v-if="openGroups.includes(groupKey + '#' + dateKey)" class="revision-table-container">
                    <table>
                      <thead>
                        <tr>
                          <th>User ID</th>
                          <th>Key</th>
                          <th>Old Value</th>
                          <th>New Value</th>
                          <th>Updated At</th>
                          <th>Updated By</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in revisions" :key="item.id">
                          <td>{{ item.user_id }}</td>
                          <td>{{ item.key }}</td>
                          <td class="old-value">{{ shortenString(item.old_value) }}</td>
                          <td class="new-value">{{ shortenString(item.new_value) }}</td>
                          <td>{{ getTimestamp(item.updated_at) }}</td>
                          <td>{{ userDisplay(item) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </transition>
              </div>
            </div>
            <div v-if="Object.keys(groupedRevisions).length === 0" class="revision-empty-group">
              <p style="text-align: center; margin-bottom: 0px;">No Revisions for this Task</p>
            </div>
            <div class="button-container">
              <button class="ins-close-button" @click="close()">Close</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      taskId: parseInt(localStorage.getItem('task_id')),
      revisions: [],
      openGroups: [],
      isVisible: false
    };
  },

  async mounted() {
    this.isVisible = true; // Ensures animation triggers when modal opens
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      let result = await axios.get('/api/revisions', { headers });

      if (result.status === 200) {
        this.revisions = result.data.filter(revision =>
          this.taskId.toString() === revision.revisionable_id.toString() &&
          revision.revisionable_type === 'Task'
        );
      }
    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
  },

  methods: {
    userDisplay(item) {
      const parts = [item.user_name, item.user_role];
      if (item.user_second_role) parts.push(item.user_second_role);
      return parts.join(', ');
    },
    close() {
      this.$emit('close');
    },
    getTimestamp(dateString) {
      const date = new Date(dateString);
      return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} ` +
        `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    },
    shortenString(value, maxLength = 100) {
      return value && value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
    },
    toggleGroup(id) {
      this.openGroups.includes(id)
        ? this.openGroups = this.openGroups.filter(group => group !== id)
        : this.openGroups.push(id);
    }
  },
  computed: {
    groupedRevisions() {
      return this.revisions.reduce((acc, revision) => {
        const groupKey = `${revision.revisionable_type}#${revision.revisionable_id}`;
        const dateObj = new Date(revision.updated_at);

        const dateKey = `${dateObj.getDate().toString().padStart(2, '0')}/` +
          `${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/` +
          `${dateObj.getFullYear()} ` +
          `${dateObj.getHours().toString().padStart(2, '0')}:` +
          `${dateObj.getMinutes().toString().padStart(2, '0')}:` +
          `${dateObj.getSeconds().toString().padStart(2, '0')}`;

        if (!acc[groupKey]) acc[groupKey] = {};
        if (!acc[groupKey][dateKey]) acc[groupKey][dateKey] = [];

        acc[groupKey][dateKey].push(revision);
        return acc;
      }, {});
    }
  }
}
</script>

<style scoped>
.trainee-list-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Expand Animation */
.modal-expand-enter-active,
.modal-expand-leave-active {
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

.modal-expand-enter-from {
  transform: scale(0.8);
  opacity: 0;
}

.modal-expand-enter-to {
  transform: scale(1);
  opacity: 1;
}

.modal-expand-leave-from {
  transform: scale(1);
  opacity: 1;
}

.modal-expand-leave-to {
  transform: scale(0.8);
  opacity: 0;
}

/* Modal Box */
.trainee-list-modal {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 1500px;
  padding: 20px;
  position: relative;
  max-height: 95%;
}

/* Slide Expand Animation for the Table */
.slide-expand-enter-active,
.slide-expand-leave-active {
  transition: max-height 0.3s ease-out, opacity 0.3s ease-out, padding 0.2s ease-in-out;
  overflow: hidden;
}

.slide-expand-enter-from,
.slide-expand-leave-to {
  max-height: 0;
  opacity: 0;
  padding: 0 20px;
}

.slide-expand-enter-to,
.slide-expand-leave-from {
  max-height: 800px;
  /* Adjust as needed */
  opacity: 1;
  padding: 10px 20px;
}

/* Table Container */
.revision-table-container {
  overflow: hidden;
  background: #f9f9f9;
  border-radius: 5px;
  padding: 10px;
}

/* Table */
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

th {
  background-color: #f1f1f1;
}

.modal-content h2 {
  margin-top: 30px;
  font-size: 30px;
  margin-bottom: 30px;
}

.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
}

.add button {
  width: 200px;
  height: 40px;
  margin-top: 50px;
  margin-bottom: 20px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.add {
  margin-top: 0;
  height: 90%;
}

button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

input.form-control,
select.form-control {
  width: 65%;
  margin-left: 200px;
  display: inline-block;
  margin-bottom: 25px;
  align-items: baseline;
}

.form-group {
  margin-bottom: 15px;
}

label {
  margin-right: 5px;
  position: absolute;
  margin-top: 8px;
}

.form-control {
  border-radius: 5px;
}

.form-control#start_date .form-control#end_date {
  border-radius: 5px;
  width: 25%;
  margin-left: 100px;
  margin-right: 45%;
}

h1 {
  margin-bottom: 20px;
}

.alert-danger {
  color: #ff0019;
  background-color: #f8d7da;
  border: 1px solid #e6b0b6;
}

.alert {
  position: relative;
  padding: .75rem 1.25rem;
  margin-bottom: 0rem;
  border: 1px solid transparent;
  border-radius: .25rem;
}

/* Data table styles */
.data-table-trainee {
  width: 99%;
  margin-left: 0.5%;
  margin-right: 0.5%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  margin-top: 0;
  align-items: left;
  margin-bottom: 30px;
}

.data-table-trainee th {
  border: 1px solid #000000bf;
  padding: 10px 5px;
  text-align: left;
  color: rgb(107, 107, 107);
  background-color: rgba(219, 219, 219, 0.804);
  margin-top: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
}

.data-table-trainee tbody tr:nth-child(odd) {
  background-color: white;
}

.data-table-trainee tbody tr:nth-child(even) {
  background-color: rgba(219, 219, 219, 0.804);
}


.data-table-trainee td {
  border: 1px solid #000000bf;
  padding: 10px 5px;
  text-align: left;
  font-weight: 500;
  margin-top: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
}

.data-table-trainee th,
.data-table-trainee td {
  text-align: left;
  /* Align content to the left */
  padding-left: 10px;
}

.data-table-trainee td.center-icons {
  text-align: center;
}

.pagination-container {
  margin-bottom: 0;
  display: flex;
  margin-left: 3%;
}

.edit-icon {
  font-size: 16px;
  /* Adjust the size as needed */
  color: #615f5f;
  /* Change the color to your preference */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.edit-icon:hover {
  color: #2b2a2a;
  /* Change the color to your preference */
  cursor: pointer;
  transform: scale(1.1);
  /* Example transform for scaling on hover */

}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  /* Red color */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  padding-left: 15px;
}

.delete-icon:hover {
  color: #a82222;
  /* Lighter red color on hover */
  cursor: pointer;
  transform: scale(1.1);
  /* Scale the icon on hover */
  /* You can also add a box-shadow or any other styles you prefer */
}

.clear-filter-button {
  position: absolute;
  right: 50px;
  top: 142px;
  width: 120px;
  border-radius: 5px;
  background-color: #dee2e6;
  font-size: 14px;
  height: 30px;
  border: 2px solid black;
  line-height: 0px;
}

.clear-filter-button:hover {
  background-color: #cecece;
  cursor: pointer;
}

.pagination-button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


.pagination-info {
  font-size: 14px;
  color: #666;
  /* Adjust the color as needed */
  position: absolute;
  top: 250px;
  left: 50%;
  /* Center horizontally */
  transform: translateX(-50%);
  /* Center horizontally */
}

.wider-column {
  width: 42%;
}

.td-logbook {
  font-size: 13px;
}


.id-column {
  width: 5%;
}

.skinny-column {
  width: 7%;
}


.revisions-container {
  margin-left: 20px;
  margin-right: 20px;
  padding: 5px;
}

.revision-sub-group {
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
}

.date-subtext {
  font-size: 0.85em;
  color: #666;
  margin-left: 8px;
}

.revision-empty-group {
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  /* Centers horizontally */
  align-items: center;
  /* Centers vertically */
  margin: 0;
}

.revision-header {
  background: #f4f4f4;
  padding: 10px;
  font-size: 1.1em;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.toggle-icon {
  font-size: 1.2em;
  font-weight: bold;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

th {
  background: #eee;
}

.old-value {
  color: red;
}

.new-value {
  color: green;
}

span {
  margin-top: 0px;
  border: none;
}

h3 {
  font-size: 1.5rem;
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  width: 120px;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 20px;
}

.ins-close-button:hover {
  background-color: #4d5358;
}
</style>